module.exports = __webpack_public_path__ + "img/no-notif.3ea50301.svg";